// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoTab_video__1DH1N","videoTab":"VideoTab_videoTab__1z5Go"};